module.exports = __webpack_public_path__ + "img/b.47d6e94e.jpg";